module.exports = __webpack_public_path__ + "assets/img/stihl-all-inclusive-price.6e2c34d8.png";